export default "__VITE_ASSET__BAdPllO___"